










































































































































import { computed, defineComponent, getCurrentInstance, reactive, watch } from '@vue/composition-api';
import { CheckCircleFilledIcon, UserIcon } from 'tdesign-icons-vue';

// 引入组件
import AddMembers, { SubmitEvent } from '@/renderer/components/dialog/AddTransfer/AddMember/index.vue';
import InviteSetting from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/InviteSetting.vue';
import CoLevelHelp, { helpHandler } from '@/renderer/components/dialog/AddTransfer/components/coLevelHelp.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import guideStepHandler from '@/renderer/components/GuideAndHelp/composition/guideStepHandler';
import useMembers, { GroupSpaceInfo } from '@/renderer/components/dialog/AddTransfer/AddMember/compositions/useMembers';

// 引入工具类
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import meetingApp from '@/renderer/scripts/utils/meeting';

import inviteExternalMembersHandler, { GenerateCodeStatus } from '../compositions/inviteExternalMembersHandler';
import inviteInternalMemberHandler from '../compositions/inviteInternalMemberHandler';

interface Props {
  manual: boolean;
  show: boolean;
  group: SMH.ColleborationSpaceInfoData;
}
export default defineComponent({
  name: 'InviteMembers',
  components: {
    CheckCircleFilledIcon,
    UserIcon,
    AddMembers,
    InviteSetting,
    CoLevelHelp,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: () => ({}),
    },
    manual: {
      type: Boolean,
      default: true,
    },
    showTemporaryMember: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    buttonTheme(val: GenerateCodeStatus, isLable: boolean) {
      if (val === GenerateCodeStatus.IS_START) {
        return isLable ? i18n_t('停止分享') : 'danger';
      }
      return isLable ? i18n_t('恢复分享') : 'success';
    },
  },
  setup(props: Props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    let guideSuccess = false;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    // const defaultRoleId = computed(() => vm.$store.getters.defaultRoleId);
    const editorRoleId = computed(() => vm.$store.getters.editorRole?.id);
    const group = computed(() => props.group || {});
    const groupId = computed(() => props.group.id || 0);
    const manual = computed(() => props.manual);
    const isPersonalAutoGenerate = computed(() => vm.$store.getters.editionFlag === 'personal' && !manual.value);
    const showDialog = reactive({
      addMembers: false,
      inviteSetting: false,
    });
    const { methods: guideStepMethods } = guideStepHandler();
    const {
      loadingUrlInfo,
      inviteUrl,
      inviteUrlInfo,
      inviteExternalFrom,
      methods: externalMemberMethods,
    } = inviteExternalMembersHandler(group);
    const codeStatus = computed(() => inviteUrlInfo.codeStatus);

    const groupSpaceInfo = computed<GroupSpaceInfo>(() => {
      return {
        type: 'group',
        groupId: props.group.id,
        spaceOrgId: props.group.orgId,
      };
    });
    const { memberData, methods: memberMethods } = useMembers(groupSpaceInfo);
    const originMembers = computed(() => memberData.list.filter(item => !item.isExternal));

    const { methods: internalMemberMethods } = inviteInternalMemberHandler(groupId);

    const { show: showHelp, openHelp } = helpHandler();
    const methods = {
      initData() {
        externalMemberMethods.initData(isPersonalAutoGenerate.value);
        memberMethods.resetData();
        memberMethods.getMembers({ pageSize: 10 });
      },
      renderRoleId(id: number) {
        const roles = vm.$store.getters.roles as Array<{
          id: number;
          name: string;
        }>;
        return roles.find(role => role.id === id)?.name || i18n_t('观察者');
      },
      toggleSettingDialog(val: boolean) {
        showDialog.inviteSetting = val;
      },
      async openInviteInternalDialog() {
        if (checkIfMobileStyle()) return;
        showDialog.addMembers = true;
        reporter.report('group', {
          group_invite: 'inner',
          group_name: group.value.name,
        });
      },
      onCopyText(val: string) {
        const copyContent = i18n_t('点击链接加入我的“{slot1}”协作群组，一起开启文件协作管理新体验吧！链接：{slot2}', {
          slot1: inviteUrlInfo.groupName,
          slot2: val,
        });
        copyText2Clipboard(copyContent)
          .then(() => {
            tips.success(i18n_t('复制成功'));
            guideSuccess = true;
          })
          .catch(() => {
            tips.error(i18n_t('复制失败'));
          });
      },
      // 分享到会议内
      async shareUrlInMeeting(url: string) {
        const desc = i18n_t('点击链接加入我的“{slot1}”协作群组', {
          slot1: inviteUrlInfo.groupName,
        });
        // 邀请弹窗出现即上报
        reporter.report('group', {
          meeting_invite: inviteUrlInfo.groupName,
        });
        const shareParams = {
          shareEnable: false,
          desc,
          // IM分享卡片描述
          notifyDesc: desc,
          // 通知弹窗描述
          pcUrl: url.replace('cofile.net', 'pan.tencent.com').replace(/dev\.|pre\./, ''),
          // 桌面端分享url，测试应用需要test前缀
          mobileUrl: url.replace('cofile.net', 'pan.tencent.com').replace(/dev\.|pre\./, ''), // 移动端分享url，测试应用需要test前缀
        };

        await meetingApp.share(shareParams, (shareResult: string) => {
          // 弹窗内点击确定或取消后上报
          reporter.report('group_invite', {
            group_name: inviteUrlInfo.groupName,
            invite_result: shareResult,
          });
        });
        meetingApp.resetShare();
      },
      changeUrlStatus() {
        const type = codeStatus.value === GenerateCodeStatus.IS_START ? 'stop' : 'recovery';
        type === 'recovery' &&
          reporter.report('group', {
            group_invite: 'outer',
            group_name: group.value.name,
          });
        externalMemberMethods.updateInviteCodeInfo(type);
      },
      changeInviteSetting(key: string, value: boolean | number) {
        const params: Record<string, any> = {};
        params[key] = value;
        externalMemberMethods.updateInviteCodeInfo(undefined, params);
      },
      async onAddMember(params: SubmitEvent) {
        const isSuccess = await internalMemberMethods.onChangeInviteMembers(params);
        if (isSuccess) {
          guideSuccess = true;
          showDialog.addMembers = false;
          methods.initData();
        }
        context.emit('refresh', {
          isSuccess,
          params,
        });
      },
      onClose() {
        if (guideSuccess) {
          // 查看新手引导是否有对应数据，如果没有，对其进行对应新建协作的更新
          guideStepMethods.monitoringStepsDone('collaborationSpace', 1);
        }
      },
    };

    watch(innerShow, val => {
      if (val) {
        methods.initData();
      }
    });
    return {
      groupId,
      copyText2Clipboard,
      innerShow,
      showDialog,
      editorRoleId,
      ...methods,
      originMembers,
      memberData,
      loadingUrlInfo,
      codeStatus,
      inviteUrl,
      inviteUrlInfo,
      inviteExternalFrom,
      externalMemberMethods,
      showHelp,
      openHelp,
    };
  },
});
